import React from "react";
import { ReduxToolkitProvider } from "./providers/reduxToolkit";
import { SupabaseProvider } from "./providers/supabase";
import { SentryProvider } from "./providers/sentry";
import { FeatureFlagsProvider } from "./providers/featureFlags";
import { ConfirmDialogProvider } from "./providers/confirmDialog";

export function Providers({children}: React.PropsWithChildren) {
  return <SentryProvider>
      <SupabaseProvider>
      <ReduxToolkitProvider>
      <FeatureFlagsProvider>
      <ConfirmDialogProvider>
        {children}
      </ConfirmDialogProvider>
      </FeatureFlagsProvider>
      </ReduxToolkitProvider>
    </SupabaseProvider>
  </SentryProvider>
}
